import { createMuiStyles } from '../../../../utils/mui';

export const adminRegisterationSectionStyles = createMuiStyles({
  heading: {
    width: {
      xs: 1,
      sm: '75%',
      md: '66%',
      xl: '50%',
    },
    mb: 5,
  },
  card: {
    py: 3.5,
    px: 3,
    bgcolor: 'grey.50',
    borderRadius: 2,
  },
  illustration: {
    height: {
      xs: '15rem',
      md: '25rem',
      lg: '30rem',
    },
    ml: 'auto',
    width: 'auto',
    display: 'block',
  },
});
